export default "__VITE_ASSET__DgxjM0v4__"